import { useDialog } from '@wui/common-library'

import { ConfirmDialog } from '../ui'

export type ConfirmDialogShowProps = {
  title: string
  message?: string
  confirmLabel?: string
  cancelLabel?: string
  textActions?: boolean
  closable?: boolean
  fitContent?: boolean
}

export const useConfirmDialog = () => {
  const { showDialog } = useDialog<boolean>()
  const show = async (props: ConfirmDialogShowProps) => {
    return await showDialog(ConfirmDialog, {
      title: props.title,
      message: props.message ?? '',
      ...(props.confirmLabel ? { confirmLabel: props.confirmLabel } : {}),
      ...(props.cancelLabel ? { cancelLabel: props.cancelLabel } : {}),
      ...(props.textActions ? { textActions: true } : {}),
      ...(props.closable === false ? { closable: false } : {}),
      ...(props.fitContent ? { fitContent: true } : {}),
      hasOverlay: true,
    })
  }

  return {
    show,
  }
}
